import { render, staticRenderFns } from "./SpinLoader.vue?vue&type=template&id=47d3cd84"
import script from "./SpinLoader.vue?vue&type=script&lang=js"
export * from "./SpinLoader.vue?vue&type=script&lang=js"
import style0 from "./SpinLoader.vue?vue&type=style&index=0&id=47d3cd84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports